// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__23DQm","input_block":"style_input_block__1yEux","button":"style_button__NxUDy","buttons":"style_buttons__3GZgA"};